import script from "./SponopAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./SponopAnimation.vue?vue&type=script&setup=true&lang=js"

import "./SponopAnimation.vue?vue&type=style&index=0&id=589ed9a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\felix\\git\\sponop\\sponop-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589ed9a2"]])

export default __exports__